import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { getResourceGridResourceProtectionFixedCacheKey } from "../../utils/helpers/fixedCacheKeys";
import { selectedResourcesAccountIdsSelector } from "../grid/selection/account/selectedResourcesAccountIdsSelector";
import { selectedResourceIdsByMasterIdSelector } from "../grid/selection/selectedResourceIdsByMasterIdSelector";
import { RootState } from "@/store/store";

const selector =
  cloudChiprApi.endpoints.patchUsersMeAccountsByAccountIdResources.select;

export const selectedResourcesProtectLoadingSelector = (
  state: RootState,
  masterGridId: string,
) => {
  const accountIds = selectedResourcesAccountIdsSelector(state, masterGridId);
  const resourceIds = selectedResourceIdsByMasterIdSelector(
    state,
    masterGridId,
  );

  if (!resourceIds?.length || !accountIds) {
    return false;
  }

  return accountIds?.some((accountId) => {
    return !!selector(
      getResourceGridResourceProtectionFixedCacheKey(resourceIds, accountId),
    )(state)?.isLoading;
  });
};
